import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Journey, IotAsset } from '../models/iotAssetsModel.data';

@Injectable({
  providedIn: 'root',
})
export class HistorialJourneyContainerService {
    private activePageSubject = new BehaviorSubject<'actia-historical-journey' | 'actia-journey' | null>('actia-historical-journey');
  activePage$ = this.activePageSubject.asObservable();


   // Nuovo BehaviorSubject per il veicolo selezionato
   private selectedVehicleSubject = new BehaviorSubject<IotAsset | null>(null);
   selectedVehicle$ = this.selectedVehicleSubject.asObservable();
 // Aggiungi un BehaviorSubject per lo stato di loading
    private journeyLoadingState = new BehaviorSubject<boolean>(false);
  public journeyLoading$ = this.journeyLoadingState.asObservable();

   // Nuovo BehaviorSubject per la lista di Journey
  private journeysListSubject = new BehaviorSubject<Journey[] | null>([]);
  journeysList$ = this.journeysListSubject.asObservable();

   // Nuovo BehaviorSubject per il trip_id selezionato
  private selectedTripIdSubject = new BehaviorSubject<string | null>(null);
  selectedTripId$ = this.selectedTripIdSubject.asObservable();


  setActivePage(page: 'actia-historical-journey' | 'actia-journey' | null): void {
    this.activePageSubject.next(page);
  }

  getActivePage(): 'actia-historical-journey' | 'actia-journey' | null {
    return this.activePageSubject.getValue();
  }

// Nuovo metodo per impostare il veicolo selezionato
setSelectedVehicle(vehicle: IotAsset ): void {
  this.selectedVehicleSubject.next(vehicle);
}

// Nuovo metodo per ottenere il veicolo selezionato corrente
getSelectedVehicle(): IotAsset | null {
  return this.selectedVehicleSubject.getValue();
}


  // Nuovo metodo per impostare la lista di Journey
  setJourneysList(journeys: Journey[] | null): void {
    this.journeysListSubject.next(journeys);
    console.log(`Journey list updated: ${journeys?.length || 0} items`);
  }

  // Nuovo metodo per ottenere la lista di Journey corrente
  getJourneysList(): Journey[] | null {
    return this.journeysListSubject.getValue();
  }


  // Metodo per impostare il trip_id selezionato
  setSelectedTripId(tripId: string | null): void {
    this.selectedTripIdSubject.next(tripId);
    console.log(`Selected trip_id updated: ${tripId}`);
  }

  // Metodo per ottenere il trip_id selezionato corrente
  getSelectedTripId(): string | null {
    return this.selectedTripIdSubject.getValue();
  }


  // Metodo per impostare lo stato di loading
  setJourneyLoading(isLoading: boolean): void {
    this.journeyLoadingState.next(isLoading);
    console.log(`Journey loading state: ${isLoading}`);
  }

  // Metodo per ottenere lo stato attuale di loading
  getJourneyLoadingState(): boolean {
    return this.journeyLoadingState.value;
  }
}
